import React from 'react';
import MobileHeader from './MobileHeader';
import MobileMenu from './MobileMenu';

const MobileLayout = ({ children }) => {
    return (
        <>
            <MobileHeader />
            <>{children} </>
            <MobileMenu />
        </>
    );
}

export default MobileLayout;